import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';

const EmailFieldInput = ({
  name,
  control,
  label,
  required = false,
  rows = 1,
  disabled=false,
  sx = {},
  varchar,
}) => {
  const labelWithAsterisk = required ? `${label} *` : label;

  const validateEmail = (email) =>
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          label={labelWithAsterisk}
          type="text"
          disabled={disabled}
          error={!!error}
          helperText={error?.message}
          rows={rows}
          value={field.value ?? ''}
          sx={sx}
          onChange={(e) => {
            const inputValue = e.target.value;
            field.onChange(inputValue);
          }}
          inputProps={{ maxLength: varchar }}
        />
      )}
    />
  );
};

export default EmailFieldInput;
